import { sanitizeHtml } from 'utils/sanitizeHtml';

/** Outlook quote styles, as the email clients write them. */
export const OUTLOOK_QUOTE_STYLES: readonly string[] = [
  'border:none;border-top:solid #E1E1E1 1.0pt;padding:3.0pt 0', // Outlook 2013  (american) <color=#E1E1E1> <unit=pt>
  'border:none;border-top:solid #E1E1E1 1.0cm;padding:3.0cm 0', // Outlook 2013 (international) <color=#E1E1E1> <unit=cm>
  'border:none;border-top:solid #B5C4DF 1.0pt;padding:3.0pt 0', // Outlook 2007, 2010 (american) <color=#B5C4DF> <unit=pt>
  'border:none;border-top:solid #B5C4DF 1.0cm;padding:3.0cm 0', // Outlook 2007, 2010 (international) <color=#B5C4DF> <unit=cm>
  'padding-top: 5px; border-top-color: rgb(229, 229, 229); border-top-width: 1px; border-top-style: solid;', // Windows Mailer
];

/** Outlook <hr /> elem style */
export const OUTLOOK_HR_STYLES: readonly string[] = [
  'display:inline-block; width:98%',
];

/**
 * Sanitize styles.
 *
 * Since the content of the message is sanitized, the style attributes might
 * differ, e.g. removed white space and/or dangling semicolons. Therefore, the
 * style attributes that are used for querying the the shadow dom should be
 * sanitized as well.
 */
function getSanitizedStyle(style: string): string {
  return (
    sanitizeHtml(`<span style="${style}"></span>`, 'email')
      .split('style="')[1]
      ?.split('">')[0] ?? ''
  );
}

/**
 * The quote styles, in the form the sanitizer rewrites them to. Empty ones are
 * dropped, as an empty style matches every element.
 */
export const SANITIZED_OUTLOOK_QUOTE_STYLES: readonly string[] =
  OUTLOOK_QUOTE_STYLES.map(getSanitizedStyle).filter(Boolean);
export const SANITIZED_OUTLOOK_HR_STYLES: readonly string[] =
  OUTLOOK_HR_STYLES.map(getSanitizedStyle).filter(Boolean);

/** Selectors for quote containers, where the node and its children are quoted. */
export const QUOTE_CONTAINER_SELECTORS: readonly string[] = [
  'blockquote',
  '.dixa_quote',
  '.dixa_quoted_message',
  'div.yahoo_quoted',
  'div.gmail_quote',
];

/** Selectors for nodes that start a quote, together with their next siblings. */
export const QUOTE_START_SELECTORS: readonly string[] = [
  '.gmail_quote_attribution',
  '.moz-cite-prefix',
];

/** Selectors for nodes whose siblings (previous/next) are all quoted content. */
export const QUOTE_SIBLING_SELECTORS: readonly string[] = [
  'br.Apple-interchange-newline',
  'spark_quote',
  '.spark_quote',
];
